import script from "./xt_vcontainer.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_vcontainer.vue?vue&type=script&setup=true&lang=js"

import "./xt_vcontainer.vue?vue&type=style&index=0&id=3147f56e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3147f56e"]])

export default __exports__